import BaseParser from './BaseParser';
import _get from 'lodash/get';

class Annotation extends BaseParser {
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getDisplayValue(fhirProperty: fhir.Annotation) {
    if (!fhirProperty) return null;

    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    return _get<fhir.Annotation, 'text', string>(fhirProperty, 'text', null);
  }
}

export default Annotation;
